import { useEffect, useState } from "react";
import { api, fmtDateTime } from "../../lib/api";
import { Chip } from "../common";
import { DateRange, monthStart, today, rangeParams } from "../DateRange";
import { ROLE_LABELS } from "../../lib/labels";

export function LoginHistory() {
  const [range, setRange] = useState({ from: monthStart(), to: today() });
  const [email, setEmail] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/login-history", { params: { ...rangeParams(range), email: email || undefined } }).then((r) => setRows(r.data));
  }, [range, email]);
  return (
    <div>
      <div className="tl-card flex flex-wrap gap-3 items-center mb-4">
        <DateRange value={range} onChange={setRange} testid="logins-range" />
        <input className="tl-input w-60" placeholder="Filtrer par e-mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="logins-email-filter" />
      </div>
      <div className="tl-card overflow-x-auto">
        <table className="tl-table" data-testid="logins-table">
          <thead><tr><th>Date et heure</th><th>Utilisateur</th><th>Profil</th><th>Résultat</th><th>Adresse IP</th><th>Appareil</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`login-row-${r.id}`}>
                <td className="whitespace-nowrap">{fmtDateTime(r.at)}</td>
                <td>{r.name || "—"}<div className="text-xs text-slate-500">{r.email}</div></td>
                <td>{ROLE_LABELS[r.role] || "—"}</td>
                <td>{r.success ? <Chip tone="green">réussie</Chip> : <Chip tone="red">refusée : {r.reason}</Chip>}</td>
                <td className="tl-mono text-xs">{r.ip}</td>
                <td className="text-xs text-slate-500 max-w-xs truncate" title={r.user_agent}>{r.user_agent}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="text-slate-500">Aucune connexion sur cette période.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
